import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=0af8e27b"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=0af8e27b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports